module.exports = __webpack_public_path__ + "static/shubham-kumar-gautam-6a65b4ed0df96875e54651411f52ba6b.jpg";